import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom"
import { AudiencePage } from "@/pages/bot-audience"
import { AudienceMemberPage } from "@/pages/bot-audience-member"
import { BroadcastPage } from "@/pages/bot-broadcast"
import { BroadcastsPage } from "@/pages/bot-broadcasts"
import { ChatsPage } from "@/pages/bot-chats"
import { FunnelEditorPage } from "@/pages/bot-funnel-editor"
import { GroupPage } from "@/pages/bot-group"
import { GroupsPage } from "@/pages/bot-groups"
import { FunnelsPage } from "@/pages/bot-funnels"
import { KeywordsPage } from "@/pages/bot-keywords"
import { MainMenuPage } from "@/pages/bot-main-menu"
import { BotPage } from "@/pages/bot-page"
import { PaymentsPage } from "@/pages/bot-payments"
import { RandomAnswersPage } from "@/pages/bot-random-answers"
import { SummaryPage } from "@/pages/bot-summary"
import { UtmPage } from "@/pages/bot-utm"
import { UtmLinkPage } from "@/pages/bot-utm-link"
import { VariablesPage } from "@/pages/bot-variables"
import { BotWorkspaceLayout } from "@/widgets/bot-workspace"

function ToBotPage({ to }: { to: string }) {
	const { botId } = useParams()
	return <Navigate to={`/admin/bots/${botId}/${to}`} replace />
}

/** Раздел бота /admin/bots/:botId/*: меню как в Botmaker и страницы разделов. */
export default function BotWorkspaceRoutes() {
	// Адрес передаётся маршрутам явно: уходящий раздел держит свой и до конца перехода
	// показывает себя, а не уже новый раздел.
	const location = useLocation()
	return (
		<BotWorkspaceLayout>
			<Routes location={location}>
				<Route index element={<ToBotPage to="analytics/summary" />} />
				<Route path="analytics" element={<ToBotPage to="analytics/summary" />} />
				<Route path="constructor" element={<ToBotPage to="constructor/funnels" />} />
				<Route path="settings" element={<ToBotPage to="settings/general" />} />

				<Route path="analytics/summary" element={<SummaryPage />} />
				<Route path="analytics/users" element={<AudiencePage />} />
				<Route path="analytics/users/:sessionId" element={<AudienceMemberPage />} />
				<Route path="analytics/groups" element={<GroupsPage />} />
				<Route path="analytics/groups/:groupId" element={<GroupPage />} />
				<Route path="analytics/utm" element={<UtmPage />} />
				<Route path="analytics/utm/:code" element={<UtmLinkPage />} />

				<Route path="constructor/main-menu" element={<MainMenuPage />} />
				<Route path="constructor/funnels" element={<FunnelsPage />} />
				<Route path="constructor/funnels/:flowId" element={<FunnelEditorPage />} />
				<Route path="constructor/chats" element={<ChatsPage />} />
				<Route path="constructor/keywords" element={<KeywordsPage />} />
				<Route path="constructor/random-answers" element={<RandomAnswersPage />} />
				<Route path="constructor/variables" element={<VariablesPage />} />

				<Route path="broadcasts/new" element={<ToBotPage to="broadcasts" />} />
				<Route path="broadcasts" element={<BroadcastsPage />} />
				<Route path="broadcasts/:broadcastId" element={<BroadcastPage />} />

				<Route path="settings/general" element={<BotPage />} />
				<Route path="settings/payments" element={<PaymentsPage />} />

				{/* Старые адреса разделов бота. */}
				<Route path="audience" element={<Navigate to="../analytics/users" replace />} />
				<Route path="broadcasts/drafts" element={<ToBotPage to="broadcasts" />} />
				<Route path="broadcasts/history" element={<ToBotPage to="broadcasts" />} />
				<Route path="analytics/variables" element={<ToBotPage to="constructor/variables" />} />
				<Route path="analytics/reports" element={<ToBotPage to="analytics/users" />} />
				<Route path="*" element={<ToBotPage to="analytics/summary" />} />
			</Routes>
		</BotWorkspaceLayout>
	)
}
